var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}

/* eslint-disable no-nested-ternary */

import axios from 'axios';
import camelcaseKeys from 'camelcase-keys';
import kebabcaseKeys from 'kebabcase-keys';
import { find } from 'lodash';
import { toast } from 'react-toastify';
import { getAccessToken, removeAccessToken } from './token';
var headers = {
  Authorization: 'Bearer ' + getAccessToken()
};
var utilsHeaders = {
  Authorization: 'Token ' + process.env.REACT_APP_UTILS_TOKEN
};
var camelcaseResponse = function camelcaseResponse(d) {
  return d && d !== 'null' ? typeof d !== 'string' ? camelcaseKeys(d, {
    deep: true
  }) : d : d;
};
var EXCLUDE_COLUMN_NAMES = ['$slice_id', '$slice_type', 'addr1', 'addr2'];
var kebabcaseRequest = function kebabcaseRequest(d, o) {
  return d && d !== 'null' ? typeof d !== 'string' ? kebabcaseKeys(d, _extends({
    deep: true,
    exclude: EXCLUDE_COLUMN_NAMES
  }, o)) : d : d;
};
var linkRelationships = function linkRelationships(d, included) {
  if (!d.relationships) return d;
  var relationships = Object.entries(d.relationships);
  relationships.forEach(function (r) {
    var data = r[1].data;
    if (Array.isArray(data)) {
      /* eslint-disable-next-line */
      d.relationships[r[0]] = data.map(function (dd) {
        return data && find(included, ['id', dd.id]);
      });
    } else {
      /* eslint-disable-next-line */
      d.relationships[r[0]] = data && find(included, ['id', data.id]);
    }
  });
  return d;
};
var linkResponseRelationships = function linkResponseRelationships(d) {
  if (!d.included) return d;
  if (Array.isArray(d.data)) {
    return Object.assign({}, d, {
      data: d.data.map(function (dd) {
        return linkRelationships(dd, d.included);
      })
    });
  }
  return Object.assign({}, d, {
    data: linkRelationships(d.data, d.included)
  });
};
var baseURL = '' + (process.env.REACT_APP_HOST_NAME ? process.env.REACT_APP_HOST_NAME : '');
var basePyURL = '' + (process.env.REACT_APP_PY_HOST_NAME ? process.env.REACT_APP_PY_HOST_NAME : process.env.REACT_APP_HOST_NAME ? process.env.REACT_APP_HOST_NAME : '');
var baseRbURL = process.env.REACT_APP_RB_HOST_NAME + '/api';
var handleBeforeRequest = function handleBeforeRequest(config) {
  return _extends({}, config, {
    headers: _extends({}, config.headers, {
      Authorization: 'Bearer ' + getAccessToken()
    })
  });
};
var hasJsonData = function hasJsonData(response) {
  return response.data && (response.headers['content-type'] === 'application/vnd.api+json' || response.headers['content-type'] === 'application/json');
};
var handleRbResponseSuccess = function handleRbResponseSuccess(response) {
  if (hasJsonData(response)) {
    response.data = camelcaseResponse(linkResponseRelationships(response.data));
  }
  return response;
};
var handlePyResponseSuccess = function handlePyResponseSuccess(response) {
  if (hasJsonData(response)) {
    response.data = camelcaseResponse(response.data);
  }
  return response;
};
var handleResponseError = function handleResponseError(error) {
  var message = error.message,
    response = error.response;
  if (message === 'Network Error' && !response) {
    toast.error(message);
  }
  var status = response.status;
  if (status !== 401 || status !== 403) {
    console.error(error);
  }
  if (status === 401) {
    removeAccessToken();
    // toast.error('Unauthorized to view this page');

    if (!window.location.pathname.includes('/login')) {
      window.location = '/login';
    }
  } else if (status === 500) {
    toast.error(message);
  }
  if (hasJsonData(response)) {
    /* eslint-disable-next-line no-param-reassign */
    error.response.data = camelcaseResponse(error.response.data);
  }
  return Promise.reject(error);
};
var common = {
  responseType: 'json'
};
var commonPyTransformResponse = [].concat(_toConsumableArray(axios.defaults.transformResponse), [camelcaseResponse]);
var commonPyConfig = _extends({}, common, {
  baseURL: baseURL
});
var commonRbTransformResponse = [].concat(_toConsumableArray(axios.defaults.transformResponse), [camelcaseResponse, function (d) {
  return d && d !== 'null' ? linkResponseRelationships(d) : d;
}]);
var commonRbConfig = _extends({}, common, {
  baseURL: baseRbURL
});
var createInstance = function createInstance(_ref) {
  var api = _ref.api,
    isAuthed = _ref.isAuthed,
    options = _objectWithoutProperties(_ref, ['api', 'isAuthed']);
  var instance = axios.create(options);
  var isPython = api === undefined || 'python'.startsWith(api);
  var isRuby = 'ruby'.startsWith(api);
  if (isAuthed) {
    instance.interceptors.request.use(handleBeforeRequest);
  }
  if (isRuby) {
    instance.interceptors.response.use(handleRbResponseSuccess, handleResponseError);
  } else if (isPython) {
    instance.interceptors.response.use(handlePyResponseSuccess, handleResponseError);
  }
  return instance;
};
var baseInstance = axios.create(_extends({}, commonPyConfig));
baseInstance.interceptors.response.use(handlePyResponseSuccess, handleResponseError);
var sessionInstance = axios.create(_extends({}, commonPyConfig));
sessionInstance.interceptors.request.use(handleBeforeRequest);
sessionInstance.interceptors.response.use(handlePyResponseSuccess, handleResponseError);
var adminInstance = axios.create(_extends({}, commonPyConfig, {
  baseURL: baseURL + '/api/admin'
}));
adminInstance.interceptors.request.use(handleBeforeRequest);
adminInstance.interceptors.response.use(handlePyResponseSuccess, handleResponseError);
var publicInstance = axios.create(_extends({}, commonPyConfig, {
  baseURL: baseURL + '/api/data/public'
}));
publicInstance.interceptors.request.use(handleBeforeRequest);
publicInstance.interceptors.response.use(handlePyResponseSuccess, handleResponseError);
var fullAuthInstance = axios.create(_extends({}, common));
fullAuthInstance.interceptors.request.use(handleBeforeRequest);
fullAuthInstance.interceptors.response.use(handlePyResponseSuccess, handleResponseError);
var authorizedInstance = axios.create(_extends({}, commonRbConfig));
authorizedInstance.interceptors.request.use(handleBeforeRequest);
authorizedInstance.interceptors.response.use(handleRbResponseSuccess, handleResponseError);
var authorizedPyInstance = axios.create(_extends({}, commonPyConfig));
authorizedPyInstance.interceptors.request.use(handleBeforeRequest);
authorizedPyInstance.interceptors.response.use(handlePyResponseSuccess, handleResponseError);
export { baseURL, basePyURL, baseRbURL, commonPyConfig, commonRbConfig, headers, utilsHeaders, camelcaseResponse, linkResponseRelationships, commonPyTransformResponse, commonRbTransformResponse, kebabcaseRequest, handleBeforeRequest, handleRbResponseSuccess, handlePyResponseSuccess, handleResponseError, createInstance, baseInstance, sessionInstance, adminInstance, fullAuthInstance, publicInstance, authorizedInstance, authorizedPyInstance };